export const primary = {
  main: '#282828',
  light: '#9E9E9E',
  contrastText: '#F2F2F2',
};
